// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const textCenter = "Layouts__textCenter__-CT8D";
export const flexLayout = "Layouts__flexLayout__vGpM-";
export const twoColumnRowLayout = "Layouts__twoColumnRowLayout__4JhRl";
export const column = "Layouts__column__gl4kQ";
export const singleColumn = "Layouts__singleColumn__P3M0Q";
export const limitedWidth = "Layouts__limitedWidth__ZT-z9";
export const header = "Layouts__header__RaZc4";
export const aside = "Layouts__aside__FtwCq";
export const sidebarLayout = "Layouts__sidebarLayout__oyuKj";
export const main = "Layouts__main__Blgt9";
export const sidebarTopLayer = "Layouts__sidebarTopLayer__cBIfo";
export const centeredColumnWrapper = "Layouts__centeredColumnWrapper__S1Tdm";
export const centeredColumn = "Layouts__centeredColumn__gcEB1";